const cLessons = [
  {
    title: "Hello World in C",
    code: `// Hello World Program
#include <stdio.h>

int main() {
    printf("Hello, World!\\n");
    return 0;
}`
  },
  {
    title: "Variables and Data Types",
    code: `// Variables and Data Types
#include <stdio.h>

int main() {
    int age = 25;
    float salary = 50000.50;
    char grade = 'A';
    double pi = 3.1415926535;
    
    printf("Age: %d\\n", age);
    printf("Salary: %.2f\\n", salary);
    printf("Grade: %c\\n", grade);
    printf("Pi: %.10f\\n", pi);
    
    return 0;
}`
  },
  {
    title: "Input and Output",
    code: `// Input and Output Operations
#include <stdio.h>

int main() {
    char name[50];
    int age;
    float height;
    
    printf("Enter your name: ");
    scanf("%s", name);
    
    printf("Enter your age: ");
    scanf("%d", &age);
    
    printf("Enter your height (in meters): ");
    scanf("%f", &height);
    
    printf("\\n--- User Information ---\\n");
    printf("Name: %s\\n", name);
    printf("Age: %d\\n", age);
    printf("Height: %.2f meters\\n", height);
    
    return 0;
}`
  },
  {
    title: "Arithmetic Operations",
    code: `// Arithmetic Operations
#include <stdio.h>

int main() {
    int a = 15, b = 4;
    
    printf("a = %d, b = %d\\n", a, b);
    printf("Addition: %d\\n", a + b);
    printf("Subtraction: %d\\n", a - b);
    printf("Multiplication: %d\\n", a * b);
    printf("Division: %d\\n", a / b);
    printf("Modulus: %d\\n", a % b);
    
    // Increment and decrement
    int x = 10;
    printf("\\nOriginal x: %d\\n", x);
    x++;
    printf("After increment: %d\\n", x);
    x--;
    printf("After decrement: %d\\n", x);
    
    return 0;
}`
  },
  {
    title: "If-Else Statement",
    code: `// If-Else Statement
#include <stdio.h>

int main() {
    int number = 10;
    
    if (number > 0) {
        printf("Number is positive\\n");
    } else if (number < 0) {
        printf("Number is negative\\n");
    } else {
        printf("Number is zero\\n");
    }
    
    // Multiple conditions
    int age = 20;
    if (age >= 18 && age <= 65) {
        printf("You are an adult\\n");
    } else if (age < 18) {
        printf("You are a minor\\n");
    } else {
        printf("You are a senior\\n");
    }
    
    return 0;
}`
  },
  {
    title: "Switch Statement",
    code: `// Switch Statement
#include <stdio.h>

int main() {
    int day = 3;
    
    switch(day) {
        case 1:
            printf("Monday\\n");
            break;
        case 2:
            printf("Tuesday\\n");
            break;
        case 3:
            printf("Wednesday\\n");
            break;
        case 4:
            printf("Thursday\\n");
            break;
        case 5:
            printf("Friday\\n");
            break;
        case 6:
            printf("Saturday\\n");
            break;
        case 7:
            printf("Sunday\\n");
            break;
        default:
            printf("Invalid day\\n");
    }
    
    // Character switch
    char grade = 'B';
    switch(grade) {
        case 'A':
            printf("Excellent!\\n");
            break;
        case 'B':
            printf("Good!\\n");
            break;
        case 'C':
            printf("Average\\n");
            break;
        default:
            printf("Need improvement\\n");
    }
    
    return 0;
}`
  },
  {
    title: "For Loop",
    code: `// For Loop
#include <stdio.h>

int main() {
    // Basic for loop
    printf("Numbers from 1 to 5:\\n");
    for(int i = 1; i <= 5; i++) {
        printf("Iteration: %d\\n", i);
    }
    
    // Loop with different increment
    printf("\\nEven numbers from 0 to 10:\\n");
    for(int i = 0; i <= 10; i += 2) {
        printf("%d ", i);
    }
    printf("\\n");
    
    // Nested for loop
    printf("\\nMultiplication table (1-3):\\n");
    for(int i = 1; i <= 3; i++) {
        for(int j = 1; j <= 3; j++) {
            printf("%d x %d = %d\\n", i, j, i * j);
        }
        printf("\\n");
    }
    
    return 0;
}`
  },
  {
    title: "While and Do-While Loops",
    code: `// While and Do-While Loops
#include <stdio.h>

int main() {
    // While loop
    int count = 1;
    printf("Counting to 5 with while loop:\\n");
    while(count <= 5) {
        printf("%d ", count);
        count++;
    }
    printf("\\n");
    
    // Do-while loop
    int number;
    printf("\\nDo-while example (enter 0 to stop):\\n");
    do {
        printf("Enter a number: ");
        scanf("%d", &number);
        printf("You entered: %d\\n", number);
    } while(number != 0);
    
    // Break and continue
    printf("\\nBreak and continue example:\\n");
    int i = 0;
    while(i < 10) {
        i++;
        if(i == 3) {
            continue; // Skip 3
        }
        if(i == 8) {
            break;    // Stop at 8
        }
        printf("%d ", i);
    }
    printf("\\n");
    
    return 0;
}`
  },
  {
    title: "Arrays",
    code: `// Arrays
#include <stdio.h>

int main() {
    // One-dimensional array
    int numbers[5] = {1, 2, 3, 4, 5};
    
    printf("Array elements:\\n");
    for(int i = 0; i < 5; i++) {
        printf("numbers[%d] = %d\\n", i, numbers[i]);
    }
    
    // Character array (string)
    char name[] = "Rajan";
    printf("\\nName: %s\\n", name);
    printf("Length of name: %lu\\n", sizeof(name) - 1);
    
    // Multi-dimensional array
    int matrix[2][3] = {
        {1, 2, 3},
        {4, 5, 6}
    };
    
    printf("\\n2D Array:\\n");
    for(int i = 0; i < 2; i++) {
        for(int j = 0; j < 3; j++) {
            printf("%d ", matrix[i][j]);
        }
        printf("\\n");
    }
    
    return 0;
}`
  },
  {
    title: "Strings and String Functions",
    code: `// Strings and String Functions
#include <stdio.h>
#include <string.h>

int main() {
    char str1[20] = "Hello";
    char str2[20] = "World";
    char str3[20];
    
    // String length
    printf("Length of '%s': %lu\\n", str1, strlen(str1));
    
    // String copy
    strcpy(str3, str1);
    printf("After strcpy: %s\\n", str3);
    
    // String concatenation
    strcat(str1, " ");
    strcat(str1, str2);
    printf("After concatenation: %s\\n", str1);
    
    // String comparison
    char password[] = "secret";
    char input[] = "secret";
    
    if(strcmp(password, input) == 0) {
        printf("Password correct!\\n");
    } else {
        printf("Password incorrect!\\n");
    }
    
    // String searching
    char text[] = "Programming in C is fun";
    char *result = strstr(text, "C");
    if(result != NULL) {
        printf("Found 'C' at position: %ld\\n", result - text);
    }
    
    return 0;
}`
  },
  {
    title: "Functions",
    code: `// Functions
#include <stdio.h>

// Function declarations
int add(int a, int b);
float calculateAverage(int arr[], int size);
void printMessage(char message[]);

int main() {
    // Basic function call
    int result = add(5, 3);
    printf("5 + 3 = %d\\n", result);
    
    // Function with array
    int numbers[] = {10, 20, 30, 40, 50};
    float avg = calculateAverage(numbers, 5);
    printf("Average: %.2f\\n", avg);
    
    // Void function
    printMessage("Hello from function!");
    
    return 0;
}

// Function definitions
int add(int a, int b) {
    return a + b;
}

float calculateAverage(int arr[], int size) {
    int sum = 0;
    for(int i = 0; i < size; i++) {
        sum += arr[i];
    }
    return (float)sum / size;
}

void printMessage(char message[]) {
    printf("Message: %s\\n", message);
}`
  },
  {
    title: "Recursion",
    code: `// Recursion
#include <stdio.h>

// Function declarations
int factorial(int n);
int fibonacci(int n);
void printNumbers(int n);

int main() {
    // Factorial using recursion
    int num = 5;
    printf("Factorial of %d: %d\\n", num, factorial(num));
    
    // Fibonacci series
    printf("\\nFibonacci series (first 10 terms):\\n");
    for(int i = 0; i < 10; i++) {
        printf("%d ", fibonacci(i));
    }
    printf("\\n");
    
    // Print numbers recursively
    printf("\\nPrinting numbers from 1 to 5:\\n");
    printNumbers(5);
    
    return 0;
}

int factorial(int n) {
    if(n == 0 || n == 1) {
        return 1;
    }
    return n * factorial(n - 1);
}

int fibonacci(int n) {
    if(n == 0) return 0;
    if(n == 1) return 1;
    return fibonacci(n - 1) + fibonacci(n - 2);
}

void printNumbers(int n) {
    if(n > 0) {
        printNumbers(n - 1);
        printf("%d ", n);
    }
}`
  },
  {
    title: "Pointers Basics",
    code: `// Pointers Basics
#include <stdio.h>

int main() {
    int number = 100;
    int *ptr = &number;
    
    printf("Value of number: %d\\n", number);
    printf("Address of number: %p\\n", &number);
    printf("Value via pointer: %d\\n", *ptr);
    printf("Pointer address: %p\\n", ptr);
    
    // Modifying value through pointer
    *ptr = 200;
    printf("\\nAfter modification through pointer:\\n");
    printf("Value of number: %d\\n", number);
    
    // Pointer arithmetic
    int arr[] = {10, 20, 30, 40, 50};
    int *arrPtr = arr;
    
    printf("\\nArray elements using pointers:\\n");
    for(int i = 0; i < 5; i++) {
        printf("arr[%d] = %d\\n", i, *(arrPtr + i));
    }
    
    // Pointer to pointer
    int x = 5;
    int *p = &x;
    int **pp = &p;
    
    printf("\\nPointer to pointer:\\n");
    printf("x = %d\\n", x);
    printf("*p = %d\\n", *p);
    printf("**pp = %d\\n", **pp);
    
    return 0;
}`
  },
  {
    title: "Pointers and Arrays",
    code: `// Pointers and Arrays
#include <stdio.h>

int main() {
    int arr[] = {1, 2, 3, 4, 5};
    int *ptr = arr;
    
    printf("Array elements using different notations:\\n");
    for(int i = 0; i < 5; i++) {
        printf("arr[%d] = %d, *(arr + %d) = %d, *(ptr + %d) = %d\\n", 
               i, arr[i], i, *(arr + i), i, *(ptr + i));
    }
    
    // Array of pointers
    char *names[] = {"Rajan", "Amit", "Priya", "Sneha"};
    int size = sizeof(names) / sizeof(names[0]);
    
    printf("\\nArray of pointers to strings:\\n");
    for(int i = 0; i < size; i++) {
        printf("Name %d: %s\\n", i + 1, names[i]);
    }
    
    // Pointer to array
    int (*arrPtr)[5] = &arr;
    printf("\\nPointer to entire array:\\n");
    printf("First element: %d\\n", (*arrPtr)[0]);
    printf("Second element: %d\\n", (*arrPtr)[1]);
    
    return 0;
}`
  },
  {
    title: "Pointers and Functions",
    code: `// Pointers and Functions
#include <stdio.h>

// Function declarations
void swap(int *a, int *b);
void modifyArray(int *arr, int size);
int stringLength(char *str);

int main() {
    // Swap using pointers
    int x = 10, y = 20;
    printf("Before swap: x = %d, y = %d\\n", x, y);
    swap(&x, &y);
    printf("After swap: x = %d, y = %d\\n", x, y);
    
    // Modify array using pointers
    int numbers[] = {1, 2, 3, 4, 5};
    printf("\\nOriginal array: ");
    for(int i = 0; i < 5; i++) {
        printf("%d ", numbers[i]);
    }
    printf("\\n");
    
    modifyArray(numbers, 5);
    
    printf("Modified array: ");
    for(int i = 0; i < 5; i++) {
        printf("%d ", numbers[i]);
    }
    printf("\\n");
    
    // String length using pointers
    char text[] = "Hello World";
    printf("\\nLength of '%s': %d\\n", text, stringLength(text));
    
    return 0;
}

void swap(int *a, int *b) {
    int temp = *a;
    *a = *b;
    *b = temp;
}

void modifyArray(int *arr, int size) {
    for(int i = 0; i < size; i++) {
        *(arr + i) *= 2; // Double each element
    }
}

int stringLength(char *str) {
    int length = 0;
    while(*str != '\\0') {
        length++;
        str++;
    }
    return length;
}`
  },
  {
    title: "Structures",
    code: `// Structures
#include <stdio.h>
#include <string.h>

// Structure definition
struct Student {
    char name[50];
    int age;
    float gpa;
    char grade;
};

// Function to print student info
void printStudent(struct Student s);

int main() {
    // Structure variable declaration and initialization
    struct Student student1;
    
    strcpy(student1.name, "Rajan");
    student1.age = 20;
    student1.gpa = 3.8;
    student1.grade = 'A';
    
    printf("Student Information:\\n");
    printStudent(student1);
    
    // Array of structures
    struct Student students[3] = {
        {"Amit", 22, 3.6, 'B'},
        {"Priya", 21, 3.9, 'A'},
        {"Sneha", 23, 3.4, 'C'}
    };
    
    printf("\\nArray of Students:\\n");
    for(int i = 0; i < 3; i++) {
        printf("Student %d: ", i + 1);
        printStudent(students[i]);
    }
    
    // Pointer to structure
    struct Student *ptr = &student1;
    printf("\\nAccessing via pointer:\\n");
    printf("Name: %s\\n", ptr->name);
    printf("Age: %d\\n", ptr->age);
    
    return 0;
}

void printStudent(struct Student s) {
    printf("Name: %s, Age: %d, GPA: %.2f, Grade: %c\\n", 
           s.name, s.age, s.gpa, s.grade);
}`
  },
  {
    title: "Structures and Functions",
    code: `// Structures and Functions
#include <stdio.h>
#include <string.h>

struct Book {
    char title[100];
    char author[50];
    float price;
    int pages;
};

// Function declarations
void printBook(struct Book b);
void updatePrice(struct Book *b, float newPrice);
struct Book createBook(char title[], char author[], float price, int pages);

int main() {
    // Create book using function
    struct Book book1 = createBook("C Programming", "Dennis Ritchie", 45.99, 300);
    
    printf("Book Details:\\n");
    printBook(book1);
    
    // Update price using pointer
    updatePrice(&book1, 39.99);
    printf("\\nAfter price update:\\n");
    printBook(book1);
    
    // Array of structures
    struct Book library[3];
    
    // Initialize array elements
    library[0] = createBook("C Programming", "Author1", 45.99, 300);
    library[1] = createBook("Data Structures", "Author2", 55.50, 400);
    library[2] = createBook("Algorithms", "Author3", 65.75, 500);
    
    printf("\\nLibrary Books:\\n");
    for(int i = 0; i < 3; i++) {
        printf("Book %d: ", i + 1);
        printBook(library[i]);
    }
    
    return 0;
}

void printBook(struct Book b) {
    printf("Title: %s, Author: %s, Price: $%.2f, Pages: %d\\n", 
           b.title, b.author, b.price, b.pages);
}

void updatePrice(struct Book *b, float newPrice) {
    b->price = newPrice;
}

struct Book createBook(char title[], char author[], float price, int pages) {
    struct Book newBook;
    strcpy(newBook.title, title);
    strcpy(newBook.author, author);
    newBook.price = price;
    newBook.pages = pages;
    return newBook;
}`
  },
  {
    title: "File Handling",
    code: `// File Handling
#include <stdio.h>
#include <stdlib.h>

int main() {
    FILE *file;
    char data[100];
    
    // Writing to a file
    file = fopen("example.txt", "w");
    if(file == NULL) {
        printf("Error opening file for writing!\\n");
        return 1;
    }
    
    fprintf(file, "Hello, this is a file handling example.\\n");
    fprintf(file, "This is line 2 of the file.\\n");
    fprintf(file, "This is line 3.\\n");
    
    fclose(file);
    printf("Data written to file successfully!\\n");
    
    // Reading from a file
    file = fopen("example.txt", "r");
    if(file == NULL) {
        printf("Error opening file for reading!\\n");
        return 1;
    }
    
    printf("\\nReading from file:\\n");
    while(fgets(data, sizeof(data), file) != NULL) {
        printf("%s", data);
    }
    
    fclose(file);
    
    // Appending to a file
    file = fopen("example.txt", "a");
    if(file == NULL) {
        printf("Error opening file for appending!\\n");
        return 1;
    }
    
    fprintf(file, "This line was appended.\\n");
    fclose(file);
    printf("\\nData appended to file successfully!\\n");
    
    return 0;
}`
  },
  {
    title: "Dynamic Memory Allocation",
    code: `// Dynamic Memory Allocation
#include <stdio.h>
#include <stdlib.h>

int main() {
    int *arr;
    int n;
    
    printf("Enter the size of array: ");
    scanf("%d", &n);
    
    // Dynamic memory allocation
    arr = (int*)malloc(n * sizeof(int));
    
    if(arr == NULL) {
        printf("Memory allocation failed!\\n");
        return 1;
    }
    
    // Input array elements
    printf("Enter %d elements:\\n", n);
    for(int i = 0; i < n; i++) {
        scanf("%d", &arr[i]);
    }
    
    // Display array elements
    printf("Array elements: ");
    for(int i = 0; i < n; i++) {
        printf("%d ", arr[i]);
    }
    printf("\\n");
    
    // Reallocate memory
    printf("\\nEnter new size for array: ");
    scanf("%d", &n);
    
    arr = (int*)realloc(arr, n * sizeof(int));
    
    printf("Enter %d new elements:\\n", n);
    for(int i = 0; i < n; i++) {
        scanf("%d", &arr[i]);
    }
    
    printf("New array elements: ");
    for(int i = 0; i < n; i++) {
        printf("%d ", arr[i]);
    }
    printf("\\n");
    
    // Free allocated memory
    free(arr);
    printf("\\nMemory freed successfully!\\n");
    
    // Dynamic allocation for 2D array
    int rows = 3, cols = 4;
    int **matrix;
    
    matrix = (int**)malloc(rows * sizeof(int*));
    for(int i = 0; i < rows; i++) {
        matrix[i] = (int*)malloc(cols * sizeof(int));
    }
    
    // Initialize 2D array
    int count = 1;
    for(int i = 0; i < rows; i++) {
        for(int j = 0; j < cols; j++) {
            matrix[i][j] = count++;
        }
    }
    
    printf("\\n2D Dynamic Array:\\n");
    for(int i = 0; i < rows; i++) {
        for(int j = 0; j < cols; j++) {
            printf("%2d ", matrix[i][j]);
        }
        printf("\\n");
    }
    
    // Free 2D array memory
    for(int i = 0; i < rows; i++) {
        free(matrix[i]);
    }
    free(matrix);
    
    return 0;
}`
  },
  {
    title: "Structures with Pointers",
    code: `// Structures with Pointers
#include <stdio.h>
#include <stdlib.h>
#include <string.h>

typedef struct {
    char name[50];
    int id;
    float salary;
} Employee;

// Function to create employee
Employee* createEmployee(char name[], int id, float salary) {
    Employee *emp = (Employee*)malloc(sizeof(Employee));
    strcpy(emp->name, name);
    emp->id = id;
    emp->salary = salary;
    return emp;
}

// Function to display employee
void displayEmployee(Employee *emp) {
    printf("ID: %d, Name: %s, Salary: $%.2f\\n", 
           emp->id, emp->name, emp->salary);
}

int main() {
    // Array of pointers to structures
    Employee *employees[3];
    
    employees[0] = createEmployee("Rajan", 101, 50000.0);
    employees[1] = createEmployee("Amit", 102, 55000.0);
    employees[2] = createEmployee("Priya", 103, 60000.0);
    
    printf("Employee Database:\\n");
    for(int i = 0; i < 3; i++) {
        displayEmployee(employees[i]);
    }
    
    // Update employee salary
    employees[0]->salary = 52000.0;
    printf("\\nAfter salary update:\\n");
    displayEmployee(employees[0]);
    
    // Free allocated memory
    for(int i = 0; i < 3; i++) {
        free(employees[i]);
    }
    
    // Linked list node structure
    typedef struct Node {
        int data;
        struct Node *next;
    } Node;
    
    // Simple linked list example
    Node *head = NULL;
    
    // Create nodes
    head = (Node*)malloc(sizeof(Node));
    head->data = 10;
    
    Node *second = (Node*)malloc(sizeof(Node));
    second->data = 20;
    head->next = second;
    
    Node *third = (Node*)malloc(sizeof(Node));
    third->data = 30;
    second->next = third;
    third->next = NULL;
    
    // Traverse linked list
    printf("\\nLinked List: ");
    Node *current = head;
    while(current != NULL) {
        printf("%d -> ", current->data);
        current = current->next;
    }
    printf("NULL\\n");
    
    // Free linked list memory
    current = head;
    while(current != NULL) {
        Node *temp = current;
        current = current->next;
        free(temp);
    }
    
    return 0;
}`
  }
];

export default cLessons;